import l10n from "diy/util/l10n";

import Api from "../Api";
import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.EMP,

    testId: "emp",
    trackingId: "EMPNotification",

    title: l10n("notifications.emp.title"),
    content: l10n("notifications.emp.content"),

    onFactory: (notificationConfig: NotificationConfig) => {
        if (typeof Api.getToolbar() !== "undefined") {
            notificationConfig.mainAction = {
                testId: "open-vcard-editor",
                label: l10n("notifications.moreDetails"),
                onClick: () => {
                    Api.getToolbar().getVCardEditor().open();
                }
            };
        }
        return notificationConfig;
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/EMP.ts
 **/